import { useState, useRef } from 'react';
import axios from 'axios';
import TourMachine from './TourMachine';

export default function TabMachines(props) {
  const machineSearchField = useRef();
  const [searchResult, setSearchResult] = useState('');
  const [chosenMachine, setChosenMachine] = useState(null);

  const chooseMachine = async (machine) => {
    await axios.post(process.env.REACT_APP_CUSTOM_URL + 'getMachineData', { machineId: machine.id })
      .then(response => {
        machine.services = [];
        machine.services.push({ id: null, name: 'Inventur', type: 'inventory', type_id: 318038893200934814, extraData: [], description: '', cancel_tstamp: null, execution_tstamp: null, spontaneous: true});
        if (response.data.machineType.services['refill'] !== undefined) {
          machine.services.push({ id: null, name: response.data.machineType.services['refill'][0].name, type: 'refill', type_id: response.data.machineType.services['refill'][0].id, extraData: response.data.products, description: response.data.machineType.services['refill'][0].description, cancel_tstamp: null, execution_tstamp: null, spontaneous: true });
        } else if (response.data.machineType.services['take back'] !== undefined) {
          machine.services.push({ id: null, name: response.data.machineType.services['take back'][0].name, type: 'take back', type_id: response.data.machineType.services['take back'][0].id, extraData: response.data.products, description: response.data.machineType.services['take back'][0].description, cancel_tstamp: null, execution_tstamp: null });
        }
        if (response.data.machineType.services['change restock'] !== undefined) {
          machine.services.push({ id: null, name: response.data.machineType.services['change restock'][0].name, type: 'change restock', type_id: response.data.machineType.services['change restock'][0].id, extraData: [], description: response.data.machineType.services['change restock'][0].description, cancel_tstamp: null, execution_tstamp: null });
        }
        if (response.data.machineType.services['settlement'] !== undefined) {
          machine.services.push({ id: null, name: response.data.machineType.services['settlement'][0].name, type: 'settlement', type_id: response.data.machineType.services['settlement'][0].id, extraData: [], description: response.data.machineType.services['settlement'][0].description, cancel_tstamp: null, execution_tstamp: null });
        }
        if (response.data.machineType.services['cleaning'] !== undefined) {
          machine.services.push({ id: null, name: response.data.machineType.services['cleaning'][0].name, type: 'cleaning', type_id: response.data.machineType.services['cleaning'][0].id, extraData: [], description: response.data.machineType.services['cleaning'][0].description, cancel_tstamp: null, execution_tstamp: null });
        }
        machine.machineType = response.data.machineType.services;
        machine.productData = response.data.products;
        machine.tubes = response.data.tubes;
        machine.missingCoinCount = response.data.missingCoinCount;
        machine.missingCoins=response.data.missingCoins;
        setChosenMachine(machine);
      }).catch(error => {
        setSearchResult(
          <div className="ui message error"><div className="header">Nicht gefunden</div> <div className="description">Die Daten für den Automaten konnten nicht abgerufen werden.</div></div>
        );
      });

  }

  const setMachineExtraData = (machineData) => {
    if (chosenMachine == null) return;
    setChosenMachine(machineData);
  }

  const setServiceQueue = (serviceData) => {
    serviceData.machineId = chosenMachine.id;
    props.setServiceQueue(serviceData);
  }

  const clearMachine = () => {
    setChosenMachine(null);
  }

  const searchMachines = () => {
    let queryStr = machineSearchField.current.value;
    if (queryStr === '') return;

    axios.post(process.env.REACT_APP_CUSTOM_URL + 'search', { query: queryStr })
      .then(response => {
        if (response.data.filtered_record_count === 0) {
          setSearchResult(
            <div className="ui message warning"><div className="header">Nicht gefunden</div> <div className="description">Zum Suchbegriff "{queryStr}" wurde kein Ergebnis gefunden.</div></div>
          );
        }
        else {
          const items = response.data.transfer_objects.map(object => <div className="item" onClick={() => chooseMachine(object)}>
            <div className="content">
              <div className="summary">
                <a href="#" className="header">Automat {object.serial_number}</a>
                <div className="meta">
                  <span className="device_number"><i className='info icon'></i> {object.device_number}</span>
                  <span className="machine_type"><i className='marker icon'></i> {object.type_name}</span>
                </div>
                <div className="description">
                  <p>{object.site_name}<br />
                    {object.site_description === '' ? '' : <span>{object.site_description}<br /></span>}
                    {object.site_address}, {object.site_zip} {object.site_city}
                  </p>
                </div>
              </div>
            </div>
          </div>);
          setSearchResult(<div className="ui divided items">
            {items}
          </div>);
        }
      }).catch(error => {
        setSearchResult(
          <div className="ui message error"><div className="header">Fehler</div> <div className="description">{error.response !== undefined ? error.response.data.title : 'Es ist ein unbekannter Fehler mit dem Code ' + error.code + ' aufgetreten'}</div></div>
        );
      });

  }


  return (
    chosenMachine === null ?
      <div>
        <h3 className="ui inverted block header">Automat suchen</h3>
        <div className="ui focus">
          <div className="ui fluid action input">
            <input className="prompt" type="text" ref={machineSearchField} placeholder="Automatennummer" onKeyDown={e => { if (e.key === 'Enter') searchMachines(); }} />
            <button className="ui icon button" onClick={e => searchMachines()}><i className="search icon"></i> Suche</button>
          </div>
          {searchResult}
        </div>
      </div>
      :
      <TourMachine machine={chosenMachine} machineType={chosenMachine.machineType} clearMachine={clearMachine} setMachineExtraData={setMachineExtraData} setServiceQueue={setServiceQueue} spontaneous={true}  userOptions={props.userOptions} />
  );
}